import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { pricing } from "@/data/landingData";

export function PricingSection({ onScrollToForm }) {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-[#050505]" id="tarifs" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="text-sm uppercase tracking-[0.3em] font-medium text-[#00FF66] mb-4 font-['Outfit',sans-serif]">NOS TARIFS</p>
          <h2 className="font-['Clash_Display',sans-serif] text-3xl sm:text-4xl font-bold tracking-tight text-white uppercase">
            Des prix transparents
          </h2>
          <p className="mt-4 text-zinc-400 max-w-2xl font-['Outfit',sans-serif]">
            Fourchettes de prix indicatives. Chaque projet est unique, demandez votre devis personnalisé gratuit.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-testid="pricing-grid">
          {pricing.map((plan, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, duration: 0.5 }}
              className={`relative p-6 transition-all duration-300 hover:-translate-y-1 ${
                plan.popular
                  ? "bg-[#00FF66] text-black"
                  : "bg-[#0a0a0a] border border-[#1a1a1a] text-white hover:border-[#00FF66]/30"
              }`}
              data-testid={`pricing-card-${idx}`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-black text-[#00FF66] px-4 py-1 text-xs font-bold uppercase tracking-wider">
                  POPULAIRE
                </div>
              )}
              <h3 className="text-lg font-bold uppercase tracking-wide font-['Outfit',sans-serif] mb-1">{plan.name}</h3>
              <p className={`text-sm mb-4 ${plan.popular ? "text-black/70" : "text-zinc-500"}`}>{plan.description}</p>
              <div className="mb-6">
                <span className="text-2xl font-black font-['Clash_Display',sans-serif]">{plan.priceRange}</span>
                <span className={`text-sm ml-1 ${plan.popular ? "text-black/70" : "text-zinc-600"}`}>HT</span>
              </div>
              <ul className="space-y-2 mb-6">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm">
                    <Check className={`w-4 h-4 ${plan.popular ? "text-black" : "text-[#00FF66]"}`} />{feature}
                  </li>
                ))}
              </ul>
              <button
                onClick={onScrollToForm}
                className={`w-full py-3 font-bold text-sm uppercase tracking-wider transition-all font-['Outfit',sans-serif] ${
                  plan.popular
                    ? "bg-black text-[#00FF66] hover:bg-black/80"
                    : "bg-[#00FF66] text-black hover:shadow-[0_0_20px_rgba(0,255,102,0.3)]"
                }`}
                data-testid={`pricing-cta-${idx}`}
              >
                Demander un devis
              </button>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 text-zinc-600 text-sm font-['Outfit',sans-serif]">
          * Prix indicatifs. Le tarif final dépend des dimensions, matériaux et complexité du projet.
          Profitez de <span className="text-[#00FF66] font-bold">500€ HT de remise</span> sur votre première commande !
        </p>
      </div>
    </section>
  );
}
